<template>
	<div>
    <div class="container is-max-desktop p-5">
      <LoginHeader/>
      <div class="columns">
          <div class="column">
            <div class="content is-flex is-flex-direction-column is-align-items-center">

                <span style="color: #19AB4F; transform: scale(1.8);" class="mdi mdi-check-circle mdi-48px"></span>

              <h3 v-html="$t('sending_form_is_success')"></h3>
              <p>{{$t('sending_form_is_success_text')}}</p>
              
              <router-link to="/login" custom v-slot="{ navigate }">
                <b-button type="is-primary" @click="navigate" role="link">{{$t('main_page')}}</b-button>
              </router-link>



            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import LoginHeader from './LoginHeader';

extend('requiredEmail', {
  ...required,
  message: 'email_is_required'
});

extend('validEmail',{
  ...email,
  message : 'please_enter_a_valid_email'
});

extend('requiredPassword', {
  ...required,
  message: 'password_is_required'
});



export default {
  name: 'Login',
  components: {
    LoginHeader,
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      
      loginForm:{
        email:'',
        password:''
      },
      labels:{
        email:{position:'',show:false},
        password:{position:'',show:false}
      }
    }
  },
  methods: {
    ...mapActions(['authenticateUser_2fa']),
    focusInput(val){
      this.labels[val].position='on-border'
      this.labels[val].show=true
    },
    blurInput(val){
      if(this.loginForm[val]==''){
        this.labels[val].show=false
      }
    },
    loginF(){
      this.authenticateUser_2fa(this.loginForm).then((response) => {
          console.log('--_2fa success response')
          console.log(response)
          if(response.status.code == '0'){
            this.$moment.locale(response.content.language)
            this.$i18n.locale = response.content.language
            this.$router.push('/')
          }
      }).catch(e => {
          console.log('--authenticateUser_2fa Error')
          console.log(e)
      })
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
</style>



// WEBPACK FOOTER //
// src/components/SendingFormIsSuccess.vue